





























import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, appModule, ISelectSceneAndMode } from '@/store/modules/ModuleApp';
import { settingsModule } from '@/store/modules/ModuleSettings';
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components';
import RightPanel from '@/components/right-panel/index.vue';
import ResizeMixin from './mixin/MixinResize';
import ComponentHeader from './components/ComponentHeader.vue';
import ComponentFooter from './components/ComponentFooter.vue';
import { IndexController } from '../views/index/index';
import { getLocalStorage } from '@tencent/s2-client-vue-lib';
import ErrorBox from '@/components/error-box/index.vue';

import './index.scss';
import { Route } from 'vue-router';
import { IUserData, userModule } from '@/store/modules/ModuleUser';

@Component({
	name: 'Layout',
	components: {
		AppMain,
		Navbar,
		RightPanel,
		Settings,
		Sidebar,
		TagsView,
		ComponentHeader,
		ComponentFooter,
		ErrorBox
	}
})
/** Layout */
export default class Layout extends mixins(ResizeMixin) {
	/** 未登录时不显示 */
	public displayValue: string = 'none';

	/** 用户信息 */
	public get userData(): IUserData {
		return userModule.userData;
	}

	/** 招标方案书数据发生改变 */
	@Watch('userData', { deep: true, immediate: true })
	public onUserDataUpdate(cur: IUserData, pre: IUserData): void {
		if (cur && cur.id) {
			this.displayValue = '';
		}
	}

	/** 是否显示面包屑 */
	public get showBreads(): boolean {
		return appModule.showBreads;
	}

	/** 是否显示错误提示框 */
	public showTips(): boolean {
		console.log(this.$route.name, '当前路由');

		return this.$route.name === 'purchaseorderEntry';
		// return false;
	}

	/** 是否显示入口页 */
	public get entranceFlag(): boolean {
		return appModule.entranceFlag;
	}

	/** 控制器 */
	public indexController!: IndexController;

	/** created */
	public async created(): Promise<any> {
		if (this.$route.path.indexOf(appModule.INDEX_PAGE_PATH) > -1) {
			appModule.setShowBreads(false);
		}
	}

	/** document hooks */
	public get classObj(): any {
		return {
			hideSidebar: !this.sidebar.opened,
			openSidebar: this.sidebar.opened,
			withoutAnimation: this.sidebar.withoutAnimation,
			mobile: this.device === DeviceType.Mobile
		};
	}

	/** document hooks */
	public get showSettings(): any {
		return settingsModule.showSettings;
	}

	/** document hooks */
	public get showTagsView(): any {
		return settingsModule.showTagsView;
	}

	/** document hooks */
	public get fixedHeader(): any {
		return settingsModule.fixedHeader;
	}

	/** document hooks */
	private handleClickOutside(): any {
		appModule.closeSideBar(false);
	}

	/** hooks */
	public mounted(): void {
		this.indexController = new IndexController();
	}
}
